export const messages = {
  validation: {
    invalidEmail: "Invalid email address",
    requiredField: "Required field",
    invalidFullName: "Full name must be at least 3 characters",
    invalidFirstName: "First name must be at least 3 characters",
    invalidLastName: "Last must be at least 3 characters",
    maximumCharacters: "Maximum characters exceed 100",
    maxCharacters: "Maximum characters exceed 150",
    minimumCharacters: "Minimum six",
    passwordExceed: "Password must be at least 6 characters",
    passwordMatch: "Passwords must match",
    httpOrHttps: "Should contain http or https",
  },
  Exception: {
    networkError: "Network Error",
    sessionExpired: "Session Expired",
  },
};
